"use strict";

var $ = require("jquery");
const { productGallery } = require("./_productGallery");

$(document).ready(function () {
    $(".bundled_product .bundled_product_image .attachment-woocommerce_thumbnail").removeClass("wp-post-image");
    productGallery();
});

window.addEventListener('resize', () => {
    productGallery();
});